jQuery(document).ready(function($) {

    const prefix = 'Area';
    const prefixSeparator = '-';

    // on smaller screens, zoom in result

    function zoomMap(objectId, widget){

        if( $(window).width() > 768) {
            return false;
        }

        // Something is wrong for at least iOS when calculating with offset top/left
        // So we provide a fallback
        if(widget.find('.svg-image-reference').find(objectId).offset().top > 1){
            var middleX = widget.find('.map-wrapper').offset().left + (widget.find('.map-wrapper').width()/2);
            var middleY = widget.find('.map-wrapper').offset().top + (widget.find('.map-wrapper').height()/2);
            var zoomX = -1*(widget.find('.svg-image-reference').find(objectId).offset().left + (widget.find('.svg-image-reference').find(objectId)[0].getBoundingClientRect().width/2) - middleX);
            var zoomY = -1*(widget.find('.svg-image-reference').find(objectId).offset().top + (widget.find('.svg-image-reference').find(objectId)[0].getBoundingClientRect().height/2) - middleY - 15);

            widget.find('.svg-image').find('svg').css('transform', 'translate(' + zoomX + 'px, ' + zoomY + 'px)');
            widget.find('.map-wrapper').addClass('zoomed');
        } else {
            // Offset is not working and calculations will fail..just display map
            widget.find('.svg-image').find('svg').css('transform', 'translate(0px, 0px)');
            widget.find('.map-info-clone').hide();
        }
    }


    function locateStore(mapPath,store, widget) {
        if(mapPath){
            var svgPath = mapPath.split(prefixSeparator);

            for(var i=0; i<map_arr.length; i++ ){
                if( map_arr[i].path === svgPath[1] ){
                    return map_arr[i];
                }
            }
        }
        if(store){
            widget.find('*[class^=st]').removeClass('active');
            widget.find('.map-wrapper').find('.sticky').remove();

            for(var z=0; z<map_arr.length; z++ ){
                if( map_arr[z].shop_id === parseFloat(store) ){

                    widget.find('.svg-image').find('#' + prefix + prefixSeparator + map_arr[z].path).addClass('active');

                    // calculate positions in percentage
                    var x = 100*((widget.find('.svg-image').find('#' + prefix + prefixSeparator + map_arr[z].path).offset().left - widget.find('.svg-image-reference').offset().left + widget.find('.svg-image').find('#' + prefix + prefixSeparator + map_arr[z].path)[0].getBoundingClientRect().width/2))/widget.find('.svg-image-reference').outerWidth() + '%';
                    var y = 100*((widget.find('.svg-image').find('#' + prefix + prefixSeparator + map_arr[z].path).offset().top - widget.find('.svg-image-reference').offset().top)/widget.find('.svg-image-reference').outerHeight()) + '%';

                    var clone = widget.find('.map-info').clone().appendTo(widget.find('.map-wrapper'));
                    clone.css('top',y);
                    clone.css('left',x);
                    clone.removeClass('map-info');
                    clone.html(map_arr[z].shop_name);
                    clone.addClass('map-info-clone sticky');

                    zoomMap('#' + prefix + prefixSeparator + map_arr[z].path, widget);
                }
            }


        }

        return false;
    }


    $('.elementor-widget-webien_store_map').each(function(){
        var widget = $(this);
        var dropdown = widget.find('.shop-dropdown');
        dropdown.select2({
            language: {
                noResults: function (params) {
                    return "Inga resultat..";
                }
            }
        });

        dropdown.on("select2:open", function() {
            widget.find('.select2-search__field').attr("placeholder", "Sök butik..");
        });
        dropdown.on("select2:close", function() {
            widget.find('.select2-search__field').attr("placeholder", null);
        });

        dropdown.on('change', function() {
            var data = dropdown.find('option:selected').val();
            locateStore(false, data, widget);
        });

        // look for initial value
        var selected = widget.find('.map-wrapper').attr('data-selected');
        if( parseFloat(selected) > 0 ){
            dropdown.val(selected).trigger('change');
        }



        widget.find('[id^=' + prefix + prefixSeparator + ']').hover(function(e) {
            var result = locateStore($(this).attr('id'),false, widget);
            if(result){
                widget.find('.map-info').addClass('show');
                widget.find('.map-info').html(result.shop_name);
                widget.find('.map-info-clone').removeClass('sticky');

            }
        });

        widget.find('[id^=' + prefix + prefixSeparator + ']').mouseleave(function(e) {
            widget.find('.map-info').removeClass('show');
            widget.find('.map-info-clone').addClass('sticky');
        });

        widget.find('.map-wrapper').mousemove(function(e) {
            var x = e.pageX - widget.find('.svg-image-reference').offset().left;
            var y = e.pageY - widget.find('.svg-image-reference').offset().top;

            widget.find('.map-info').css('top',y);
            widget.find('.map-info').css('left',x);
        }).mouseover();

        widget.find('[id^=' + prefix + prefixSeparator + ']').click(function(e) {
            var result = locateStore($(this).attr('id'),false, widget);
            if(result){
                window.location.href = result.href;
            } else {
                console.log('No link.');
            }


        });

    });

});


